@if ((loadingService.isLoading())) {
  <app-main-loading type="spinner-grow"></app-main-loading>
}

@if (oidc.isAuthenticated() | async) {
  @let holidayNotifications = holidayNotificationsService.notifications();
  @let notifications = notificationsService.notifications();

  @let showNotifications = notificationsPanelService.openNotifications();

  <div class="notifications-overlay" [ngClass]="{ 'open': showNotifications }"></div>

  <div class="notifications-wrapper" [ngClass]="{ 'open': showNotifications }">
    @if (showNotifications && (holidayNotifications?.length || notifications?.length)) {
      <app-notifications-panel [holidayNotifications]="holidayNotifications"
                               [notifications]="notifications"/>
    }
  </div>
}

@if (shortcutService.chordActive() && !shortcutService.isNavigationOpen()) {
  <app-chord-indicator [shortcutRows]="shortcutRows"
                       [shortcutPrefix]="shortcutPrefix"/>
}

<router-outlet/>
